import React from 'react';
import styled from 'styled-components';

const StyledSubNavTag = styled.p`
margin-top: 0;
color: ${props => props.tagFontColor};
font-weight: bold;
`

export default StyledSubNavTag;